import React from 'react';
import { motion } from 'framer-motion';
import { RotateCw } from 'lucide-react';
import { VocabularyWord } from './VocabularyCard';
interface FlashCardProps {
  word: VocabularyWord;
  isFlipped: boolean;
  onFlip: () => void;
}
export function FlashCard({
  word,
  isFlipped,
  onFlip
}: FlashCardProps) {
  return <div className="relative w-full max-w-sm mx-auto h-[500px] flex-shrink-0" style={{
    perspective: '1000px'
  }} data-id="element-11">
      <motion.div className="w-full h-full relative cursor-pointer" animate={{
      rotateY: isFlipped ? 180 : 0
    }} transition={{
      duration: 0.6,
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} onClick={onFlip} style={{
      transformStyle: 'preserve-3d'
    }} data-id="element-12">
        {/* Front Side (Kanji Only) */}
        <div className="absolute inset-0 w-full h-full bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center overflow-hidden" style={{
        backfaceVisibility: 'hidden'
      }} data-id="element-13">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#E63946]" data-id="element-14" />

          <div className="flex flex-col items-center justify-center" data-id="element-15">
            <h2 className="text-6xl font-bold text-gray-900 mb-4 tracking-wide font-sans" data-id="element-16">
              {word.kanji}
            </h2>
            <p className="text-sm text-gray-400 mt-4 flex items-center gap-2" data-id="element-17">
              <RotateCw size={16} data-id="element-18" />
              Tap to flip
            </p>
          </div>
        </div>

        {/* Back Side (Details) */}
        <div className="absolute inset-0 w-full h-full bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center text-center overflow-hidden" style={{
        backfaceVisibility: 'hidden',
        transform: 'rotateY(180deg)'
      }} data-id="element-19">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#E63946]" data-id="element-20" />

          <div className="flex flex-col items-center justify-center w-full" data-id="element-21">
            {/* Meaning */}
            <div className="w-full mb-6" data-id="element-22">
              <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-23">
                {word.meaning}
              </h3>
            </div>

            {/* Separator */}
            <div className="w-full border-t border-gray-100 mb-6" data-id="element-24"></div>

            {/* Hiragana & Kanji */}
            <div className="mb-6" data-id="element-25">
              <h2 className="text-4xl font-bold text-gray-900 mb-2 font-sans" data-id="element-26">
                {word.kanji}
              </h2>
              <p className="text-2xl text-gray-500 font-medium" data-id="element-27">
                {word.hiragana}
              </p>
            </div>

            {/* Pitch Accent */}
            <div className="h-16 flex items-center justify-center gap-1 relative" data-id="element-28">
              {word.pitchPattern.map((pitch, index) => <div key={index} className="flex flex-col items-center z-10 w-10" style={{
              marginTop: pitch === 1 ? '-25px' : '25px'
            }} data-id="element-29">
                  <div className={`
                    w-4 h-4 rounded-full border-2 transition-colors duration-300
                    ${pitch === 1 ? 'bg-[#E63946] border-[#E63946]' : 'bg-white border-gray-300'}
                  `} data-id="element-30" />
                  <span className="text-xs text-gray-400 mt-2 font-mono" data-id="element-31">
                    {word.hiragana[index]}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}